/**
 * errorHandler is a singleton which allows users to log errors and get a list of subscribers.
 * It initializes the subscribers if they haven't already been initialized and does so only
 * once per instance.
 */
export var errorHandler = function handlerFactory() {
  return {
    getSubscribers: function getSubscribers() {
      return errorHandler.errorSubscribers || {};
    }
  };
}();
export function initializeErrorHandler(BUGSNAG_CONFIG_PAYLOAD_KEY) {
  if (typeof errorHandler.errorSubscribers !== 'undefined') {
    return;
  }
  errorHandler.errorSubscribers = {};
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof errorHandler.errorSubscribers.bugsnagClient === 'undefined' && typeof window.bugsnag !== 'undefined' && !window.bugsnag.initialized) {
    var config = BUGSNAG_CONFIG_PAYLOAD_KEY;
    if (config) {
      errorHandler.errorSubscribers.bugsnagClient = window.bugsnag(config);
    }
  } else if (typeof window.bugsnag !== 'undefined') {
    errorHandler.errorSubscribers.bugsnagClient = window.bugsnag.client;
  }
  if (typeof errorHandler.errorSubscribers.splunkRum === 'undefined' && typeof window.SplunkRum !== 'undefined') {
    errorHandler.errorSubscribers.splunkRum = window.SplunkRum;
  }
  errorHandler.errorSubscribers.user = function (err, msg, metaData) {
    // eslint-disable-next-line no-console
    console.error(err.toString(), msg, metaData);
  };
}
function tellBugsnag(err, msg) {
  var metaData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  try {
    var client = errorHandler.getSubscribers().bugsnagClient;
    if (client) {
      var BugsnagReport = client.BugsnagReport;
      var handledState = {
        severity: 'warning',
        unhandled: false,
        severityReason: {
          type: 'handledException'
        }
      };
      var report = new BugsnagReport(err.name, msg ? "".concat(err.message, " - ").concat(msg) : err.message, BugsnagReport.getStacktrace(err), handledState);
      report.updateMetaData('extra', metaData);
      client.notify(report);
    }
  } catch (doNothingWithError) {
    console.log(doNothingWithError); // eslint-disable-line
  }
}

function tellSplunkRum(err, msg) {
  var metaData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  try {
    var client = errorHandler.getSubscribers().splunkRum;
    if (client) {
      // This function works like console.error, so we don't really pass in
      // objects to it. If we want to capture that info, we need to pass it in
      // as a string; thus the JSON.stringify so we don't lose granularity.
      client.error(err, msg, JSON.stringify(metaData));
    }
  } catch (doNothingWithError) {
    // eslint-disable-next-line no-console
    console.log(doNothingWithError);
  }
}
function tellUser(err, msg, metaData) {
  var client = errorHandler.getSubscribers().user;
  if (client) {
    client(err, msg, metaData);
  }
}

/**
 *
 * @param {Error} err - Error object
 * @param {string} msg - {optional extra message}
 * @param {Object} metaData - [optional metadata object]
 */
errorHandler.logError = function logError(err) {
  if (!err) return;
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  var message = rest[0],
    metaData = rest[1];
  if (typeof rest[0] === 'object' && rest.length === 1) {
    message = null;
    metaData = rest[0];
  }
  tellBugsnag(err, message, metaData);
  tellSplunkRum(err, message, metaData);
  tellUser(err, message, metaData);
};
//# sourceMappingURL=errorHandler.js.map